const address = "Москва, Путевой проезд 3с1, к 902";

export default address;
